module.exports = __webpack_public_path__ + "static/media/Stunky_gaussian2.2ee70963.png";